import healthcareLogo from '../../assets/healthcare logo.png';
import React, { useState, useEffect, useRef } from 'react';
import LoginModal from '../modals/Loginmodal';
import SignupModal from '../modals/Signupmodal';
import HQLoginModal from '../modals/HQLoginModal';
import HQSignupModal from '../modals/HQSignupModal';
import './Navbar.css';

const NAV_LINKS = [
  { label: 'Features',     href: '#features'     },
  { label: 'Workflow',     href: '#workflow'      },
  { label: 'Why Us',       href: '#why'           },
  { label: 'Modules',      href: '#modules'       },
];
const Navbar = ({ openSignupOnMount = false, prefillEmail = '' }) => {  const [scrolled,       setScrolled]       = useState(false);
  const [mobileOpen,     setMobileOpen]     = useState(false);  const [loginDropdown,  setLoginDropdown]  = useState(false);
  const [signupDropdown, setSignupDropdown] = useState(false);
  const [modal, setModal] = useState(null);

  const loginRef  = useRef(null);
  const signupRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (loginRef.current  && !loginRef.current.contains(e.target))  setLoginDropdown(false);
      if (signupRef.current && !signupRef.current.contains(e.target)) setSignupDropdown(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const close      = () => setMobileOpen(false);
  const closeModal = () => setModal(null);

useEffect(() => {
    if (openSignupOnMount) {
      openModal('hqSignup');
    }
  }, [openSignupOnMount]);

  const openModal = (type) => {
    setModal(type);
    setLoginDropdown(false);
    setSignupDropdown(false);
    close();
  };

  return (
    <>
      <nav className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
        <div className="container navbar__inner">
          <a href="/" className="navbar__logo">
            <img src={healthcareLogo} alt="Healthcare Logo" style={{ height: '170px', width: '400px', objectFit: 'contain' }} />
          </a>

          <ul className={`navbar__links${mobileOpen ? ' navbar__links--open' : ''}`}>
            {mobileOpen && (
              <li className="navbar__mobile-close">
                <button onClick={close} className="navbar__close-btn" aria-label="Close menu">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </li>
            )}
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a href={link.href} onClick={close}>{link.label}</a>
              </li>
            ))}
            <li className="navbar__mobile-auth">
              <button className="navbar__login-btn--mobile" onClick={() => openModal('buLogin')}>Branch Login</button>
              <button className="navbar__login-btn--mobile" onClick={() => openModal('hqLogin')}>HQ Login</button>
              <button className="navbar__signup-btn--mobile" onClick={() => openModal('hqSignup')}>14 Days Free Trial</button>
            </li>
          </ul>

          <div className="navbar__actions">
            <div className="navbar__dropdown-wrap" ref={loginRef}>
              <button className="navbar__login-btn" onClick={() => { setLoginDropdown(v => !v); setSignupDropdown(false); }}>
                Log In
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ marginLeft: '5px' }}><polyline points="6 9 12 15 18 9"></polyline></svg>
              </button>
              {loginDropdown && (
                <div className="navbar__dropdown">
                  <button onClick={() => openModal('buLogin')}>Branch Login</button>
                  <button onClick={() => openModal('hqLogin')}>Head Quarters</button>
                </div>
              )}
            </div>

            <button className="navbar__signup-btn" onClick={() => openModal('hqSignup')}>
              14 Days Free Trial
            </button>
          </div>

          <button
            className={`navbar__hamburger${mobileOpen ? ' navbar__hamburger--open' : ''}`}
            onClick={() => setMobileOpen(v => !v)}
            aria-label="Toggle navigation"
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      <LoginModal    isOpen={modal === 'buLogin'}  onClose={closeModal} onSwitchToSignup={() => openModal('buSignup')} />
      <SignupModal   isOpen={modal === 'buSignup'} onClose={closeModal} onSwitchToLogin={() => openModal('buLogin')} />
      <HQLoginModal  isOpen={modal === 'hqLogin'}  onClose={closeModal} onSwitchToSignup={() => openModal('hqSignup')} />
<HQSignupModal isOpen={modal === 'hqSignup'} onClose={closeModal} onSwitchToLogin={() => openModal('hqLogin')} prefillEmail={prefillEmail} />    </>
  );
};

export default Navbar;
